import Purchases from '@/views/Purchases/Index'
import PurchasesRequests from '@/views/Purchases/Requests/Index'
import PurchasesRequestsRequest from '@/views/Purchases/Requests/Request'
import PurchasesRequestsExternalRequest from '@/views/Purchases/Requests/ExternalRequest'
import PurchasesMaterialReservations from '@/views/Purchases/MaterialReservations/Index'


export default [
    {
        path: '/purchases',
        name: 'purchases',
        component: Purchases,
        meta: {
            title: 'Purchases',
            menuRendered: true,
            menuTitle: 'Zakupy',
            icon: 'mdi-shopping-outline'
        },
        children: [
            {
                path: '/purchases/material-reservations',
                name: 'purchasesMaterialReservations',
                component: PurchasesMaterialReservations,
                meta: {
                    title: 'Zakupy / Rezerwacje materiałów',
                    menuRendered: true,
                    menuTitle: 'Rezerwacje materiałów',
                    requiresAuth: true,
                    permission: 'material_reservations',
                },
            },
            {
                path: '/purchases/requests',
                name: 'purchasesRequests',
                component: PurchasesRequests,
                meta: {
                    menuRendered: true,
                    menuTitle: 'Zapotrzebowania',
                    title: 'Zakupy / Zapotrzebowania / Lista zapotrzebowań',
                    requiresAuth: true,
                    permission: 'requests',
                },
            },
            {
                path: '/purchases/requests/create',
                name: 'purchasesRequestsCreate',
                component: PurchasesRequestsRequest,
                meta: {
                    title: 'Zakupy / Zapotrzebowania / Nowe zapotrzebowanie',
                    requiresAuth: true,
                    permission:  'requests_create'
                },
            },
            {
                path: '/purchases/requests/edit/:id',
                name: 'purchasesRequestsEdit',
                component: PurchasesRequestsRequest,
                meta: {
                    title: 'Zakupy / Zapotrzebowania / Edycja zapotrzebowania',
                    requiresAuth: true,
                    permission:  'requests_read',
                },
            },
            {
                path: '/purchases/requests/externalRequest/create',
                name: 'purchasesRequestsExternalRequestCreate',
                component: PurchasesRequestsExternalRequest,
                meta: {
                    title: 'Zakupy / Zapotrzebowania / Nowe zapytanie',
                    requiresAuth: true,
                    permission:  'requests_update',
                },
            },
            {
                path: '/purchases/requests/externalRequest/:id',
                name: 'purchasesRequestsExternalRequestRead',
                component: PurchasesRequestsExternalRequest,
                meta: {
                    title: 'Zakupy / Zapotrzebowania / Szczegóły zapytania',
                    requiresAuth: true,
                    permission:  'requests_update',
                },
            },
        ]
    },
]